import React from "react";

import { sectionIconMap, SeverityLevel } from "@shared/interfaces/Anomaly";
import { ServerFile } from "@shared/interfaces/ProjectsFiles";

interface StatusIconProps {
  file: ServerFile;
  handleShowPopup: (fileId: string, file?: ServerFile) => void;
  triggerStatusPopup: (severity: string, anomaly_count: number) => void;
  clearStatusPopup: () => void;
}

const StatusIcon: React.FC<StatusIconProps> = ({
  file,
  handleShowPopup,
  triggerStatusPopup,
  clearStatusPopup,
}) => {
  let altText = "No issues";
  let severity: SeverityLevel = SeverityLevel.Success;

  if (file.anomaly_count > 0) {
    const level = file.max_anomalies_severity ?? SeverityLevel.High;
    altText = "Issues found";
    severity = level;
  }

  const icon =
    file.unresolved_anomaly_count == 0
      ? sectionIconMap["Success"]
      : sectionIconMap[severity];

  const handleMouseEnter = () =>
    triggerStatusPopup(severity, file.unresolved_anomaly_count);
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    handleShowPopup(file.id, file);
  };

  return (
    <div
      className="cursor-pointer px-4 py-1"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={clearStatusPopup}
      onClick={handleClick}
    >
      <img src={icon} className="2xl:w-6 2xl:h-6 w-5 h-6" alt={altText} />
    </div>
  );
};

export default StatusIcon;
